import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    marginHorizontal: -16,
    marginTop: 12,
  },
  subtitle: {
    fontSize: 24,
    lineHeight: 30,
    fontFamily: Fonts.type.VodafoneLt,
    marginBottom: 16,
  },
  topViewScannerStyle: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginHorizontal: 16,
  },
  separator: theme => ({
    height: 1,
    marginTop: 16,
    marginHorizontal: 16,
    backgroundColor: theme.colors.divider,
  }),
  cameraContainerStyle: {
    overflow: 'hidden',
  },
  scannerContainerStyle: {
    elevation: 0,
    zIndex: 0,
    alignSelf: 'center',
  },
});
